<template>
    <div>
      <h2>{{ model }} List</h2>
      <ag-grid-vue
        class="ag-theme-alpine"
        :rowData="rows"
        :columnDefs="columns"
        :rowSelection="'single'"
        @rowClicked="onRowClicked"
        style="width: 100%; height: 500px;"
      />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import axiosInstance from "@/api/axios";
  
  const props = defineProps({
    model: { type: String, required: true },
  });
  const emit = defineEmits(['update:selectedData']);
  
  const rows = ref([]);
  const columns = ref([]);
  
  const fetchSchema = async () => {
    try {
      const schemaResponse = await axiosInstance.get(`/schema/${props.model}/`);
      const schema = schemaResponse.data;
      columns.value = schema.fields.map((field) => ({
        headerName: field.verbose_name || field.name,
        field: field.name,
      }));
    } catch (error) {
      console.error('Error fetching schema:', error);
    }
  };
  
  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`/${props.model.toLowerCase()}s/`);
      rows.value = response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  
  const onRowClicked = (event) => {
    emit('update:selectedData', event.data);
  };
  
  onMounted(async () => {
    await fetchSchema();
    await fetchData();
  });
  </script>
  
  <!-- ⚠ scoped 유지 — 과거 .ag-theme-alpine 전역 누수로 타 그리드 화면 높이를 오염시켰음 (2026-06-11) -->
  <style scoped>
  /* Ag-Grid Alpine 테마 CSS */
  .ag-theme-alpine {
    height: 100%;
    width: 100%;
  }
  </style>
  